import type { ReactNode } from 'react';

export interface PageHeaderProps {
  /** 페이지 제목. string 또는 ReactNode (배지 등 인라인 요소 포함 시) */
  title: ReactNode;
  subtitle?: string;
  breadcrumb?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, breadcrumb, actions }: PageHeaderProps) {
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'var(--spacing-4) var(--spacing-6)',
        borderBottom: '1px solid var(--color-surface-border)',
        background: 'var(--color-surface-background)',
      }}
    >
      <div>
        {breadcrumb && (
          <div
            style={{
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-text-secondary)',
              marginBottom: 'var(--spacing-1)',
            }}
          >
            {breadcrumb}
          </div>
        )}
        <h1
          style={{
            margin: 0,
            fontSize: 'var(--font-size-xl)',
            color: 'var(--color-text-primary)',
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            style={{
              margin: 'var(--spacing-1) 0 0',
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-text-secondary)',
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div style={{ display: 'flex', gap: 'var(--spacing-2)' }}>{actions}</div>}
    </header>
  );
}
